import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { TradingOffer } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { TradingOfferStatusCounts } from 'types/TradingOffer';

type GetTradingOffersProps = {
  societyId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

type TradingOfferApiGetAllResponse = {
  data: TradingOffer[];
  total: number;
  statusCount: TradingOfferStatusCounts;
};

export const getTradingOffers =
  ({ societyId, params = {}, signal }: GetTradingOffersProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/tradingOffers', {
        params: {
          societyId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as TradingOfferApiGetAllResponse;

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
